import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      actions: false
    }
  },
  props: {
    guest: {
      type: Object,
      require: true
    }
  },
  methods: {
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/guest/index/components/resources/index.js